const Sort = ({
  sortConfig,
  sortOptions,
  setSortColumn,
  toggleSortDirection,
}) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1">
        <label className="block text-[11px] text-gray-500 mb-1">Ordenar por</label>
        <select
          value={sortConfig.column}
          onChange={(e) => setSortColumn(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-white"
        >
          {sortOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
      <div className="pt-[18px]">
        <button
          type="button"
          onClick={toggleSortDirection}
          className="h-[38px] px-3 border border-gray-300 rounded bg-white text-sm"
        >
          {sortConfig.direction === 'asc' ? '↑' : '↓'}
        </button>
      </div>
    </div>
  );
};

export default Sort;
